import React from "react";
import {NavLink} from "react-router-dom";
import "./mainNavBar.scss";
import logo from "../../assets/images/logo.svg";
import user from "../../assets/images/user.svg";
// import search from "../../assets/images/search.svg";

function MainNavBar() {
    return (
        <div className="main-navbar">
            <nav className="navbar navbar-expand-lg navbar-light container">
                <a className="navbar-brand" href="/">
                    <img src={logo} alt="alif logo"/>
                </a>
                <button
                    className="navbar-toggler mr-3"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse navbar-toggleable-lg"
                     id="navbarSupportedContent">
                    <ul className="navbar-nav mr-auto">
                        <li className="nav-item">
                            <a className="nav-link"
                               href="https://alif.tj/deposit">
                                Депозиты
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link"
                               href="https://alif.academy">
                                Академия
                            </a>
                        </li>
                        <li className="nav-item">
                            <NavLink className="active-nav-link"
                                     to="/">
                                Салом
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link"
                               href="https://alif.shop">
                                alif.shop
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link"
                               href="https://alifmobi.tj/">
                                alif mobi
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link"
                               href="https://job.alif.tj">
                                Вакансии
                            </a>
                        </li>
                        <li className="nav-item">
                            <div className="dropdown">
                                <NavLink className="nav-link dropdown-toggle"
                                         to=""
                                         id="dropdownMenuLink"
                                         data-toggle="dropdown"
                                         aria-haspopup="true"
                                         aria-expanded="false">
                                    Еще
                                </NavLink>
                                <div className="dropdown-menu dropdown-menu-center"
                                     aria-labelledby="dropdownMenuLink">
                                    <a className="dropdown-item"
                                       href="https://alifpay.tj">
                                        alif pay
                                    </a>
                                    <a className="dropdown-item"
                                       href="https://auto.alif.tj">
                                        Покупка авто
                                    </a>
                                    <a className="dropdown-item"
                                       href="https://km.alif.mobi">
                                        Карты
                                    </a>
                                    <a className="dropdown-item"
                                       href="https://intiqol.tj">
                                        Переводы
                                    </a>
                                </div>
                            </div>
                        </li>
                    </ul>

                    {
                        /*<div className="my-2 my-lg-0">
                          <a className="nav-link action-link">
                              <img src={search} alt="user-icon"/>
                          </a>
                      </div>

                      <div className="my-2 my-lg-0 ctm-language">
                          <div className="dropdown">
                              <NavLink className="nav-link dropdown-toggle ctm-selected-language"
                                       to=""
                                       id="dropdownMenuLink2"
                                       data-toggle="dropdown"
                                       aria-haspopup="true"
                                       aria-expanded="false">
                                  RU
                              </NavLink>
                              <div className="dropdown-menu dropdown-menu-center dropdown-menu-language"
                                   aria-labelledby="dropdownMenuLink2">
                                  <a className="dropdown-item">
                                      TJK
                                  </a>
                                  <a className="dropdown-item">
                                      USD
                                  </a>
                              </div>
                          </div>
                      </div>*/
                    }

                    <div className="my-2 my-lg-0">
                        <a className="nav-link action-link" href="https://online.alif.tj">
                            <img src={user} alt="user-icon"/> Вход
                        </a>
                    </div>
                </div>
            </nav>
        </div>
    );
}

export default MainNavBar;
